class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.resetButton = this.querySelector('button[type="reset"]');
      this.closeButton = this.querySelector('[data-close-search]');
      this.isInModal = this.closest('details-modal') !== null;
  
      if (this.input) {
        this.input.form.addEventListener('reset', this.onFormReset.bind(this));
        this.input.addEventListener('input', this.updateTextState.bind(this));
        this.input.addEventListener(
          'input',
          debounce((event) => {
            this.onChange(event);
          }, 300).bind(this)
        );
      }
      
      // Only attach close button handler if not in a modal (modal handles closing itself)
      if (this.closeButton && !this.isInModal) {
        this.closeButton.addEventListener('click', this.onCloseClick.bind(this));
      }

      this.updateTextState();
    }
    
    updateTextState() {
      if (!this.input || !this.input.form) return;
      const hasText = this.input.value.trim().length > 0;
      this.input.form.classList.toggle('search--has-text', hasText);
    }

    onCloseClick(event) {
      event.preventDefault();
      
      // Don't handle close if we're in a modal (let the modal handle it)
      if (this.isInModal) {
        return;
      }
      
      // If this is a PredictiveSearch instance, close it
      if (this.close && typeof this.close === 'function') {
        this.close(true);
      } else {
        // Otherwise, try to find and close a predictive search parent
        const predictiveSearch = this.closest('predictive-search');
        if (predictiveSearch && predictiveSearch.close) {
          predictiveSearch.close(true);
        }
      }
      
      // Close modal if it exists (only for non-modal versions)
      const detailsModal = this.closest('details-modal');
      if (detailsModal && detailsModal.close && !this.isInModal) {
        detailsModal.close();
      }
      
      // Clear the input
      if (this.input) {
        this.input.value = '';
        this.input.blur();
      }

      this.updateTextState();
    }
  

  
    onChange() {
    }
  
    shouldResetForm() {
      return !document.querySelector('[aria-selected="true"] a');
    }
  
    onFormReset(event) {
      // Prevent default so the form reset doesn't set the value gotten from the url on page load
      event.preventDefault();
      // Don't reset if the user has selected an element on the predictive search dropdown
      if (this.shouldResetForm()) {
        this.input.value = '';
        this.input.focus();
      }

      this.updateTextState();
    }
  }
  
  customElements.define('search-form', SearchForm);